import { FormHelperText } from "@mui/material";

import { fieldMessageId } from "ui/forms/field-message/field-message.helpers";
import {
  FIELD_MESSAGE_ICON_SIZE,
  FIELD_MESSAGE_ROW_SX,
  FIELD_WARNING_MESSAGE_SX,
} from "ui/forms/field-message/field-message.styles";
import { type FieldMessageProps } from "ui/forms/field-message/field-message.types";
import { mergeSx } from "ui/merge-sx";

import Icons from "assets";

export const FieldHelperText = ({ name, message, sx, ...rest }: FieldMessageProps) => {
  if (!message) {
    return null;
  }

  return (
    <FormHelperText
      id={fieldMessageId(name, "helperText")}
      data-testid="helper-text"
      sx={sx}
      {...rest}>
      {message}
    </FormHelperText>
  );
};

export const FieldErrorMessage = ({ name, message, sx, ...rest }: FieldMessageProps) => {
  if (!message) {
    return null;
  }

  return (
    <FormHelperText
      error
      id={fieldMessageId(name, "error")}
      role="alert"
      data-testid="error-message"
      sx={mergeSx(FIELD_MESSAGE_ROW_SX, sx)}
      {...rest}>
      <Icons.ExclamationCircle width={FIELD_MESSAGE_ICON_SIZE} height={FIELD_MESSAGE_ICON_SIZE} />
      <span>{message}</span>
    </FormHelperText>
  );
};

export const FieldWarningMessage = ({ name, message, sx, ...rest }: FieldMessageProps) => {
  if (!message) {
    return null;
  }

  return (
    <FormHelperText
      id={fieldMessageId(name, "warning")}
      data-testid="warning-message"
      sx={mergeSx(FIELD_MESSAGE_ROW_SX, FIELD_WARNING_MESSAGE_SX, sx)}
      {...rest}>
      <Icons.WarningIndicator width={FIELD_MESSAGE_ICON_SIZE} height={FIELD_MESSAGE_ICON_SIZE} />
      <span>{message}</span>
    </FormHelperText>
  );
};
